import { Navigate } from 'react-router-dom'

import LoadingComponent from 'components/LoadingComponent'

import { useUser } from 'UserContext'

const PublicRoute = ({ children }) => {
  const { user, isLoading } = useUser()

  if (isLoading) return <LoadingComponent />

  if (user) {
    return <Navigate to="/" replace />
  }

  return children
}

export default PublicRoute
